import React, { useEffect, Fragment, memo } from 'react';
export function Faq() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-290" data-mp="2j5uujw9uitai">
      <div className="legal-hero" data-id="element-291" data-mp="2j6nvggm4iokq">
        <p className="legal-overline" data-id="element-292" data-mp="2y2d7blxlhlbq">Todo lo que necesitas saber</p>
        <h1 className="legal-title" data-id="element-293" data-mp="2xzh9rypnsynt">Preguntas frecuentes</h1>
        <p className="legal-subtitle" data-id="element-294" data-mp="2t1xwp24p6rxg">
          Si tienes una duda que no está aquí, escríbenos por WhatsApp.
        </p>
      </div>
      <div className="faq-grid" data-id="element-295" data-mp="3705nesb54x06">
        {/* SOBRE EL PRODUCTO */}
        <div className="faq-categoria" data-id="element-296" data-mp="322nkpjnpve0m">
          <h2 className="faq-categoria-titulo" data-id="element-297" data-mp="3gsbpwvz0qwtm">Sobre el producto</h2>
          <div className="faq-item" data-id="element-298" data-mp="3grjtxk1iex2t">
            <h3 data-id="element-299" data-mp="3btib907zwzrv">¿De qué están hechas las velas SAVIA?</h3>
            <p data-id="element-300" data-mp="3btqm6mkk5v0f">
              100% cera de soya vegetal, libre de parafina y derivados del
              petróleo. Usamos fragrancias de alta calidad con las notas
              indicadas en cada producto. La mecha es de algodón natural.
            </p>
          </div>
          <div className="faq-item" data-id="element-301" data-mp="2658ahx6epvg0">
            <h3 data-id="element-302" data-mp="2669sympr5k7r">¿Cuánto dura una vela SAVIA?</h3>
            <p data-id="element-303" data-mp="2a5ilxpcyxe29">
              Las velas de 210g tienen una duración aproximada de 40 a 50 horas
              de quemado continuo, dependiendo del entorno y las corrientes de
              aire. Para mayor duración, quémala en sesiones de 2 a 3 horas
              máximo.
            </p>
          </div>
          <div className="faq-item" data-id="element-304" data-mp="2p447thdkapy2">
            <h3 data-id="element-305" data-mp="2p32jwcbg68yx">¿Las velas son tóxicas o peligrosas?</h3>
            <p data-id="element-306" data-mp="2t44koxl0it30">
              No. La cera de soya es completamente vegetal y no produce los
              gases tóxicos que libera la parafina. Es una opción segura para
              hogares con mascotas y niños, aunque siempre recomendamos usar las
              velas bajo supervisión de un adulto.
            </p>
          </div>
          <div className="faq-item" data-id="element-307" data-mp="37vdj9w6w7osa">
            <h3 data-id="element-308" data-mp="3cswv6pg4bph2">¿Por qué mi vela se ve diferente a la foto?</h3>
            <p data-id="element-309" data-mp="3ctf34jc57s4t">
              Cada vela es hecha a mano. Pueden existir variaciones sutiles en
              superficie, color y acabado entre piezas — esto es una
              característica del proceso artesanal, no un defecto. Lo que no
              varía nunca es la fragancia.
            </p>
          </div>
          <div className="faq-item" data-id="element-310" data-mp="2wwns680tc1r1">
            <h3 data-id="element-311" data-mp="2s3b3xz01pwyt">¿Qué es la "memoria del melt pool"?</h3>
            <p data-id="element-312" data-mp="2s1rlq2utxbue">
              La primera vez que enciendes tu vela, déjala quemar hasta que toda
              la superficie esté líquida (aprox. 2–3 horas). Esto evita el
              "tunneling" y garantiza que aproveches toda la cera.
            </p>
          </div>
        </div>
        {/* SOBRE LOS PEDIDOS */}
        <div className="faq-categoria" data-id="element-313" data-mp="3fr2nnnnx1ca4">
          <h2 className="faq-categoria-titulo" data-id="element-314" data-mp="3avdnpj7zhtda">Pedidos y envíos</h2>
          <div className="faq-item" data-id="element-315" data-mp="1lfe4taekcpkg">
            <h3 data-id="element-316" data-mp="1lgfn9zxwsec7">¿Cuándo llega mi pedido?</h3>
            <p data-id="element-317" data-mp="1lh8t8yp1mzta">
              Producimos en 2–4 días hábiles después del pago. El envío toma 1–2
              días adicionales en Bogotá y 3–7 días en el resto del país. Total
              estimado: entre 3 y 11 días hábiles.
            </p>
          </div>
          <div className="faq-item" data-id="element-318" data-mp="w236s9q3ar0">
            <h3 data-id="element-319" data-mp="z6esapip8rp">¿Puedo hacer un pedido personalizado?</h3>
            <p data-id="element-320" data-mp="3id21rkmcq53f">
              Para pedidos corporativos, kits personalizados o cantidades
              mayores a 10 unidades, escríbenos directamente por WhatsApp.
              Tenemos opciones especiales para regalos empresariales y eventos.
            </p>
          </div>
          <div className="faq-item" data-id="element-321" data-mp="3dfa224fgteoo">
            <h3 data-id="element-322" data-mp="3dgbkityt93gf">¿Puedo recoger mi pedido en Bogotá?</h3>
            <p data-id="element-323" data-mp="2zfip870oq4c9">
              Por el momento no contamos con punto de venta físico. Solo
              despachamos a domicilio. Bogotá tiene los tiempos de entrega más
              rápidos.
            </p>
          </div>
          <div className="faq-item" data-id="element-324" data-mp="xonp52zg3izq">
            <h3 data-id="element-325" data-mp="xljebmrh5p03">¿Cómo sé que mi pedido está confirmado?</h3>
            <p data-id="element-326" data-mp="12lnvlf07inrd">
              Recibirás una confirmación por WhatsApp o correo electrónico una
              vez procesado el pago. Si después de 2 horas no recibes
              confirmación, escríbenos directamente.
            </p>
          </div>
          <div className="faq-item" data-id="element-327" data-mp="2toxuynrt28er">
            <h3 data-id="element-328" data-mp="2poe1bu6fxmxd">¿Hacen envíos internacionales?</h3>
            <p data-id="element-329" data-mp="2pr9wjaqwlxi4">
              Por ahora solo enviamos dentro de Colombia. Si estás fuera del
              país y quieres un pedido, escríbenos — evaluamos caso a caso.
            </p>
          </div>
        </div>
        {/* SOBRE REGALOS */}
        <div className="faq-categoria" data-id="element-330" data-mp="2b011un859ly4">
          <h2 className="faq-categoria-titulo" data-id="element-331" data-mp="2ayyegpa161my">Regalos y kits</h2>
          <div className="faq-item" data-id="element-332" data-mp="2627z6461va2l">
            <h3 data-id="element-333" data-mp="25z3m0halx3zs">¿El empaque viene listo para regalar?</h3>
            <p data-id="element-334" data-mp="220mdpufg9ngs">
              Sí. Cada pedido viene en caja kraft natural con papel mantequilla,
              sticker SAVIA y tarjeta editorial con frase de la colección. No
              enviamos con precio visible — ideal para regalo.
            </p>
          </div>
          <div className="faq-item" data-id="element-335" data-mp="7jmnz57idze5">
            <h3 data-id="element-336" data-mp="7ibbmgzzzjbf">¿Puedo agregar un mensaje personalizado?</h3>
            <p data-id="element-337" data-mp="ci7da9l82ynt">
              Sí. Al finalizar la compra puedes escribir el mensaje que quieres
              incluir en la tarjeta. Lo escribimos a mano con la misma intención
              con que hacemos cada vela.
            </p>
          </div>
          <div className="faq-item" data-id="element-338" data-mp="lilzrc9xajsw">
            <h3 data-id="element-339" data-mp="3ky97giji3jh4">¿Qué incluye el Kit Ritual SAVIA?</h3>
            <p data-id="element-340" data-mp="3kzk8wbph4f52">
              El Kit Ritual incluye un pebetero SAVIA, un pack de Fragmentos
              Aromáticos × 6 y el aroma que elijas al comprar. Todo en empaque
              kraft premium con tarjeta editorial. Precio: $89.000 COP.
            </p>
          </div>
        </div>
      </div>
    </div>;
}